import { FileSearchOutlined } from '@ant-design/icons';
import { Modal, Tabs } from 'antd';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { summaryStore } from '../../Article/Documents/store';
import logoN from '../../assets/logo-normal.png';
import { GroupBuyingOrderPanel } from '../../components/GroupBuyingOrder/GroupBuyingOrder';
import { OrderModal } from '../Order/OrderModal';
import styles from './index.module.scss';
import { selectPackageEntitlement } from '../../Service/packageEntitlements';

/** 「订单查询」弹窗的两个标签页：生成订单（下载 / 编辑）与已购套餐 */
const ORDER_TAB = 'orders';
const PACKAGE_TAB = 'packages';

export const Nav = observer(({ hasBottomBorder = false, bgWhite = false }) => {
    // 订单查询弹窗：两个标签页（订单与下载 / 我的套餐）
    const [orderQuery, setOrderQuery] = useState({ open: false, tab: ORDER_TAB });
    const nav = useNavigate();
    const location = useLocation();

    const [initialOrderNo, setInitialOrderNo] = useState('');

    const openOrderQuery = (tab = ORDER_TAB) => setOrderQuery({ open: true, tab });
    const closeOrderQuery = () => setOrderQuery((prev) => ({ ...prev, open: false }));

    // 检测URL参数中的transactionNum
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const transactionNum = searchParams.get('transactionNum');

        if (transactionNum) {
            // 设置初始订单号
            setInitialOrderNo(transactionNum);
            // 打开「订单查询」的订单与下载页
            setOrderQuery({ open: true, tab: ORDER_TAB, mode: 'query' });

            // 清空地址栏中的transactionNum参数
            searchParams.delete('transactionNum');
            const newSearch = searchParams.toString();
            const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
            nav(newUrl, { replace: true });
        }
    }, [location.search, location.pathname, nav]);

    const toHome = () => {
        // summaryStore.reset();
        nav('/');
        window.document.scrollingElement?.scrollTo(0, 0);
        window.location.reload();
    };

    const isExample = location.pathname === '/example';
    const shouldShowBorder = [1, 2].includes(summaryStore.currentStep) || hasBottomBorder;

    // 首页正在创作时，选中的套餐直接用于当前创作
    const packageOnSelect =
        location.pathname === '/' && summaryStore.paperInfo ? selectPackageEntitlement : undefined;
    const orderPanel = (
        <OrderModal
            editBtnText="编辑"
            initialOrderNo={initialOrderNo}
            handleOk={closeOrderQuery}
        />
    );

    const handleNavKey = (event, action) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            action();
        }
    };

    // 背景 / 底线用 class 控制：手机上统一改成磨砂白底 + 细线（滚动时页面内容不会透上来）
    const wrapperClass = [
        styles.navWrapper,
        bgWhite || isExample ? styles.solid : '',
        shouldShowBorder ? styles.bordered : '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <>
            <div className={wrapperClass}>
                <div className={styles.nav}>
                    <img
                        src={logoN}
                        alt="灵感风暴"
                        className={`h-5 w-auto cursor-pointer md:h-12`}
                        onClick={toHome}
                    />
                    <div className={styles.content}>
                        <div
                            className={`${styles.item} flex items-center gap-2 text-primary`}
                            onClick={() => {
                                nav('/eightPieceSet');
                            }}
                        >
                            论文套餐
                        </div>
                        <div
                            role="button"
                            tabIndex={0}
                            className={`${styles.item} ${styles.queryItem}`}
                            onClick={() => openOrderQuery(ORDER_TAB)}
                            onKeyDown={(event) =>
                                handleNavKey(event, () => openOrderQuery(ORDER_TAB))
                            }
                        >
                            <FileSearchOutlined />
                            订单查询
                        </div>
                    </div>
                    <Modal
                        title="订单查询"
                        open={orderQuery.open}
                        onCancel={closeOrderQuery}
                        footer={null}
                        width={800}
                    >
                        <Tabs
                            className={styles.queryTabs}
                            activeKey={orderQuery.tab}
                            onChange={(tab) => setOrderQuery((prev) => ({ ...prev, tab }))}
                            items={[
                                {
                                    key: ORDER_TAB,
                                    label: '订单与下载',
                                    children: orderPanel,
                                },
                                {
                                    key: PACKAGE_TAB,
                                    label: '我的套餐',
                                    children: (
                                        <GroupBuyingOrderPanel
                                            visible={
                                                orderQuery.open &&
                                                orderQuery.tab === PACKAGE_TAB
                                            }
                                            onSelect={packageOnSelect}
                                            onClose={closeOrderQuery}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </Modal>
                </div>
            </div>
        </>
    );
});
